// extracted by mini-css-extract-plugin
export default {"popup_menu":"ExamMenu_popup_menu__dhOmp","show_menu":"ExamMenu_show_menu__i-P2l","menu_item":"ExamMenu_menu_item__E7xNX"};